import { render, staticRenderFns } from "./ReviewSettingsModal.vue?vue&type=template&id=39db1e36"
import script from "./ReviewSettingsModal.vue?vue&type=script&lang=ts"
export * from "./ReviewSettingsModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports